<app-navbar></app-navbar>
<main>
  <router-outlet></router-outlet>
  <app-scroll-top></app-scroll-top>
</main>
<app-footer></app-footer>